import type { ContentCardProps } from '@mdvip/shared/components/blocks/ContentCard';

import type { WellnessArticle } from './wellnessApi';

// Transparent, so the card's own `bg-muted` media frame shows through as the empty image slot.
export const WELLNESS_IMAGE_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E";

/** `id` is the HealthDay vendor id, an arbitrary string, so it is encoded before it reaches the path. */
export function wellnessArticleHref(id: string): string {
  return `/resources/wellness/${encodeURIComponent(id)}`;
}

/**
 * WellnessArticle -> ContentCardProps. `formatDate` is the caller's locale-aware date formatter;
 * `savedIds` is the screenful's bookmark check, since the article itself carries no saved flag.
 * Stays pure: the caller supplies `onSaveChange`.
 */
export function toWellnessArticleCard(
  article: WellnessArticle,
  formatDate: (date: string) => string,
  savedIds: ReadonlySet<string>,
): ContentCardProps {
  return {
    title: article.title,
    description: article.blurb ?? undefined,
    imageSrc: article.imageUrl ?? undefined,
    imagePlaceholder: WELLNESS_IMAGE_PLACEHOLDER,
    meta: article.postingDate ? [{ icon: 'calendar', label: formatDate(article.postingDate) }] : [],
    href: wellnessArticleHref(article.id),
    savable: true,
    saved: savedIds.has(article.id),
  };
}
